import { render, staticRenderFns } from "./PlaybackSpeedButton.vue?vue&type=template&id=2fe0dd2b&scoped=true&"
import script from "./PlaybackSpeedButton.vue?vue&type=script&lang=js&"
export * from "./PlaybackSpeedButton.vue?vue&type=script&lang=js&"
import style0 from "./PlaybackSpeedButton.vue?vue&type=style&index=0&id=2fe0dd2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe0dd2b",
  null
  
)

export default component.exports